import { render, staticRenderFns } from "./ClicMetabaseChart.vue?vue&type=template&id=1370e3df&"
import script from "./ClicMetabaseChart.vue?vue&type=script&lang=js&"
export * from "./ClicMetabaseChart.vue?vue&type=script&lang=js&"
import style0 from "./ClicMetabaseChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports